import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getParam } from 'controls/utils';
import { logout, authPlugin } from 'actions/auth';
import Loader from 'components/atoms/Spinner/Loader';
import { Button } from 'components/atoms/Button/Button';
import { Language } from 'language/Language';
import { strings, supportLinks } from './strings';
import AuthForm from './AuthForm';

const AuthPlugin = () => {
  const [loginSuccess, setLoginSuccess] = useState(undefined);
  const [IsDoneRequest, setIsDoneRequest] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state);
  const language = Language();
  const logoutParam = getParam('logout');
  const port = getParam('port');
  const redirected = getParam('redirected');

  const handleLogout = useCallback(async () => {
    await dispatch(logout(history, `${language === 'japan' ? '/jp' : ''}/auth/plugin`));
  }, [dispatch, history, language]);

  const getResult = useCallback(async () => {
    if (userInfo && !redirected) {
      const result = await dispatch(authPlugin(userInfo.za, userInfo.refreshToken, port));
      setLoginSuccess(result || false);
    } else {
      return true;
    }
  }, [dispatch, port, redirected, userInfo]);

  useEffect(() => {
    if (logoutParam === 'true') {
      handleLogout();
    }
    if (redirected) {
      history.push(`${language === 'japan' ? '/jp' : ''}/auth/plugin${port ? `&port=${port}` : ''}`);
    } else if (userInfo && !logoutParam && !IsDoneRequest) {
      setIsDoneRequest(true);
      getResult();
    }
  }, [IsDoneRequest, getResult, handleLogout, history, language, logoutParam, port, redirected, userInfo]);

  return (
    <>
      {userInfo && loginSuccess === undefined
        && (
          <Loader />
        )}
      {userInfo
        ? (
          <div style={{
            textAlign: 'center', paddingTop: '3rem', maxWidth: '900px', margin: '0 auto',
          }}
          >
            {userInfo && loginSuccess === true
              && (
                <h1>{strings[language].success}</h1>
              )}

            {userInfo && loginSuccess === false
              && (
                <>
                  <h1>{strings[language].error}</h1>
                  <Button
                    isWorking={0}
                    onClick={getResult}
                    text={strings[language].again}
                  />
                  <p>{strings[language].or}</p>
                  <a href={supportLinks[language]}>{strings[language].support}</a>
                </>
              )}
          </div>
        )
        : (
          <AuthForm />
        )}
    </>
  );
};

export default AuthPlugin;
